import { useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'

import { IConfirmationDialogContentProps } from '../models/IConfirmationDialogProps'

import styles from './ConfirmationDialogContent.module.scss'

export const ConfirmationDialogContent = (props: IConfirmationDialogContentProps) => {
  const {
    title,
    content,
    hasComment,
    applyKey,
    onApply,
    isApplyDisabled,
    isApplyNegative,
    discardKey,
    onDiscard,
    isHideDiscard,
    cancelKey,
    onCancel,
    isHideCancel,
  } = props

  const [comment, setComment] = useState('')

  const handleApply = useCallback(() => {
    onApply(comment)
  }, [comment, onApply])

  const handleDiscard = useCallback(() => {
    if (!isHideCancel && onDiscard) {
      onDiscard(comment)
    }
  }, [comment, isHideCancel, onDiscard])

  return (
    <div className={styles.content}>
      <div className={styles.title}>
        <h5 className={styles.title}>
          <Translation text={title} span />
        </h5>
      </div>
      <div>{typeof content === 'string' ? <Translation text={content} span /> : content}</div>
      {hasComment && (
        <Input
          classes={{
            root: styles.comment,
          }}
          type="text"
          label="Comment"
          onChange={setComment}
          value={comment}
        />
      )}
      <div className={styles.actions}>
        <Button
          onClick={handleApply}
          disabled={isApplyDisabled}
          color={isApplyNegative ? 'danger' : 'primary'}
        >
          <Translation text={applyKey ?? 'Apply'} span />
        </Button>
        {!isHideDiscard && (
          <Button onClick={handleDiscard} color="grey">
            <Translation text={discardKey ?? 'Discard'} span />
          </Button>
        )}
        {!isHideCancel && (
          <Button onClick={onCancel} color="grey">
            <Translation text={cancelKey ?? 'Cancel'} span />
          </Button>
        )}
      </div>
    </div>
  )
}
